
function getFileIcon(name){
  const ext=(name||'').split('.').pop().toLowerCase();
  const map={pdf:'📄',doc:'📄',docx:'📄',xls:'📈',xlsx:'📈',ppt:'📄',pptx:'📄',jpg:'🖼️',jpeg:'🖼️',png:'🖼️',gif:'🖼️',webp:'🖼️',mp4:'🎬',mov:'🎬',mp3:'🎵',zip:'🗜️',rar:'🗜️',txt:'📄',csv:'📈'};
  return map[ext]||'📄';
}

function formatBytes(bytes){
  if(!bytes) return '';
  if(bytes<1024) return bytes+'B';
  if(bytes<1024*1024) return (bytes/1024).toFixed(1)+'KB';
  return (bytes/1024/1024).toFixed(1)+'MB';
}
